export default __webpack_public_path__ + "static/media/alacart_menu_gomb.0be0e917.png";